module.exports = __webpack_public_path__ + "img/favicon.f72322b5.png";